import { $authHost } from "../../http";
import { 
    REFERRAL_ADDITIONAL_INFO_GET_REQUEST, REFERRAL_ADDITIONAL_INFO_GET_SUCCESS, REFERRAL_ADDITIONAL_INFO_GET_ERROR, 
    REFERRAL_ADDITIONAL_INFO_GET_BY_KEY_REQUEST, REFERRAL_ADDITIONAL_INFO_GET_BY_KEY_SUCCESS, REFERRAL_ADDITIONAL_INFO_GET_BY_KEY_ERROR, 
    REFERRAL_ADDITIONAL_INFO_ADD_REQUEST, REFERRAL_ADDITIONAL_INFO_ADD_SUCCESS, REFERRAL_ADDITIONAL_INFO_ADD_ERROR, 
    REFERRAL_ADDITIONAL_INFO_EDIT_REQUEST, REFERRAL_ADDITIONAL_INFO_EDIT_SUCCESS, REFERRAL_ADDITIONAL_INFO_EDIT_ERROR, 
    REFERRAL_ADDITIONAL_INFO_DELETE_REQUEST, REFERRAL_ADDITIONAL_INFO_DELETE_SUCCESS, REFERRAL_ADDITIONAL_INFO_DELETE_ERROR
} from "../constants/referralAdditionalInfoConstants";

export const getReferralAdditionalInfos = (args) => async (dispatch) => {
    try {
        dispatch({
            type: REFERRAL_ADDITIONAL_INFO_GET_REQUEST
        });
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        const {data} = await $authHost.post(
            "/api/v1/referralAdditionalInfo/query",
            args || {},
            config,
        );
        dispatch({
            type: REFERRAL_ADDITIONAL_INFO_GET_SUCCESS,
            payload: data.result,
        });
        return data.result;
    } catch (error) {
        dispatch({
            type: REFERRAL_ADDITIONAL_INFO_GET_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const getReferralAdditionalInfoByKey = (id) => async (dispatch) => {
    try {
        dispatch({
            type: REFERRAL_ADDITIONAL_INFO_GET_BY_KEY_REQUEST
        });

        const {data} = await $authHost.get(
            `/api/v1/referralAdditionalInfo/${id}`,
        );
        dispatch({
            type: REFERRAL_ADDITIONAL_INFO_GET_BY_KEY_SUCCESS,
            payload: data,
        });
        return data.result;
    } catch (error) {
        dispatch({
            type: REFERRAL_ADDITIONAL_INFO_GET_BY_KEY_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const addReferralAdditionalInfo = ({ name, code, description }, queryArgs) => async (dispatch) => {
    try {
        dispatch({
            type: REFERRAL_ADDITIONAL_INFO_ADD_REQUEST
        });
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        await $authHost.post(
            "/api/v1/referralAdditionalInfo",
            { name, code, description },
            config,
        );
        dispatch(getReferralAdditionalInfos(queryArgs || {}));
        dispatch({
            type: REFERRAL_ADDITIONAL_INFO_ADD_SUCCESS,
        });
    } catch (error) {
        dispatch({
            type: REFERRAL_ADDITIONAL_INFO_ADD_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const editReferralAdditionalInfo = ({ id, name, code, description }, queryArgs) => async (dispatch) => {
    try {
        dispatch({
            type: REFERRAL_ADDITIONAL_INFO_EDIT_REQUEST
        });
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        await $authHost.put(
            "/api/v1/referralAdditionalInfo",
            { id, name, code, description },
            config,
        );
        dispatch(getReferralAdditionalInfos(queryArgs || {}));
        dispatch({
            type: REFERRAL_ADDITIONAL_INFO_EDIT_SUCCESS,
        });
    } catch (error) {
        dispatch({
            type: REFERRAL_ADDITIONAL_INFO_EDIT_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const deleteReferralAdditionalInfo = (id, queryArgs) => async (dispatch) => {
    try {
        dispatch({
            type: REFERRAL_ADDITIONAL_INFO_DELETE_REQUEST
        });
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        await $authHost.delete(
            "/api/v1/referralAdditionalInfo",
            { data: { id } },
            config,
        );
        dispatch(getReferralAdditionalInfos(queryArgs || {}));
        dispatch({
            type: REFERRAL_ADDITIONAL_INFO_DELETE_SUCCESS,
        });
    } catch (error) {
        dispatch({
            type: REFERRAL_ADDITIONAL_INFO_DELETE_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

